import { render, staticRenderFns } from "./EditFolderNamePopUp.vue?vue&type=template&id=f47085c0&scoped=true"
import script from "./EditFolderNamePopUp.vue?vue&type=script&lang=js"
export * from "./EditFolderNamePopUp.vue?vue&type=script&lang=js"
import style0 from "./EditFolderNamePopUp.vue?vue&type=style&index=0&id=f47085c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47085c0",
  null
  
)

export default component.exports